import request from '@/router/axios';
import qs from 'qs'
/**
 * 新增和修改
 * @param {{id:number,taxNo:String}} params
 * @returns {Promise}
 */
export const save = (data)=>request.post('/api/cube-agent/ag_produccharge_records/submit',data)
/**
 * 删除
 */
export const del = (data)=>request.post('/api/cube-agent/ag_produccharge_records/remove',qs.stringify(data))
/**
 * 认领代收款和内部报销
 */
export const saveAgChargeInto = (data)=>request.post('/api/cube-agent/ag_charge_claim_details/saveAgChargeInto',data)
/**
 * 调动记录分页
 */
export const distributiontList = (params)=>request.get('/api/cube-agent/company_distribution_records/distributiontList',{params})
